/* import __COLOCATED_TEMPLATE__ from './vet-services-set-scores.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import clsx from 'clsx';

import { INPUT_FIELDS } from 'sh-www/components/lsg/lsg-decimal-input';

const CLASS_NAME = 'SH-c-admin-vet-services-set-scores';

class VetServicesSetScores extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get inputFieldWhole() {
    return INPUT_FIELDS.WHOLE;
  }

  get inputFieldDecimal() {
    return INPUT_FIELDS.DECIMAL;
  }

  /**
   * @returns {Object} of form obj[serviceId][part]
   */
  get defaultServiceScoreInputs() {
    const scoreDefaults = this.args.defaultServiceScores;

    return Object.keys(scoreDefaults).reduce((accum, serviceId) => {
      const calculatedScore = scoreDefaults[serviceId] ?? 0;
      // [whole, decimal]
      accum[serviceId] = calculatedScore.toFixed(1).split('.').map(Number);

      return accum;
    }, {});
  }

  /**
   * @returns {boolean}
   */
  get isAddUnlistedServiceDisabled() {
    return !this.args.selectedUnlistedService;
  }

  /**
   * @returns {Object} of form obj[serviceId][part]
   */
  get finalServiceScoreInputs() {
    const scoreDefaults = this.args.defaultServiceScores;
    const scoreOverrides = this.args.serviceRatingOverrides;

    const finalScores = { ...this.defaultServiceScoreInputs };

    return Object.keys(scoreOverrides).reduce((accum, serviceId) => {
      const calculatedScore = scoreDefaults[serviceId] ?? 0;
      const [currentWhole, currentDecimal] = calculatedScore.toFixed(1).split('.').map(Number);

      const newRating = scoreOverrides[serviceId];
      const whole = newRating[INPUT_FIELDS.WHOLE] ?? currentWhole;
      const decimal = newRating[INPUT_FIELDS.DECIMAL] ?? currentDecimal;
      accum[serviceId] = [whole, decimal];

      return accum;
    }, finalScores);
  }

  @action
  onSetServiceRating(serviceId, inputName, rating) {
    if (INPUT_FIELDS.WHOLE === inputName && !rating) {
      this.args.handleClearServiceRating('serviceRatings', serviceId);
      return;
    }

    this.args.handleSetServiceRating('serviceRatings', serviceId, inputName, rating);
  }

  @action
  onSetServiceRatingOverride(serviceId, inputName, rating) {
    // if an override is cleared we assume the service should be unrated
    if (INPUT_FIELDS.WHOLE === inputName && !rating) {
      // set both inputs to undefined so that the field clears
      this.args.handleSetServiceRatingOverride('serviceRatingOverrides', serviceId, INPUT_FIELDS.WHOLE, undefined);
      this.args.handleSetServiceRatingOverride('serviceRatingOverrides', serviceId, INPUT_FIELDS.DECIMAL, undefined);
      return;
    }

    this.args.handleSetServiceRatingOverride('serviceRatingOverrides', serviceId, inputName, rating);
  }
}

export default VetServicesSetScores;
